module.exports = "/_next/static/images/27a1823611e4d1292f156e22688fcc2b-hero-patadita-dorada-1x.jpg";